/** Computer Search or Pokédex, once played: the cards picked from the deck go to the server. */
export const LOOK = 'TRAINER/LOOK';
export const END_LOOK = 'TRAINER/END_LOOK';
/** Clefairy Doll: discarded from play during the turn. */
export const DISCARD_FROM_PLAY = 'TRAINER/DISCARD_FROM_PLAY';
export const END_DISCARD_FROM_PLAY = 'TRAINER/END_DISCARD_FROM_PLAY';

/** What the server's game turn `looking` says the player is doing with their deck. */
export const SEARCH_DECK = 'search_deck';
export const POKEDEX = 'pokedex';
export const TRADE_POKEMON = 'trade_pokemon';
